module.exports = __webpack_public_path__ + "static/img/top-1.eaeab98.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter/top-1.png
// module id = T4kf
// module chunks = 1